import { Component, Input, OnInit, HostListener, OnDestroy } from '@angular/core';
import { takeUntil, finalize } from "rxjs/operators";

import { OB } from "@admin/full-transcript/pages/ob-report/ob.namespace";
import { PediatricEncounter } from '../../../areas/admin/pediatric-encounter/pediatric-encounter.namespace';
import { PEncounter } from '../../models/pediatric-encounter.model';
import { Appointment, PreviousAppointment } from '../../entities';
import { ApiResources } from "@shared/helpers";
import { HttpService, AppData, EncounterCommunication } from "@shared/services";
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

import { Page, IUserAccount, PatientProfile, IEncounterResource } from "@shared/models";

@Component({
    selector: 'pediatrics-header',
    templateUrl: './pediatrics-header.html'
})
export class PediatricsHeaderComponent implements OnInit, OnDestroy {
  
    page: Page;   



    //services end

    patient: PatientProfile;
    measurements: PediatricEncounter.Measurements;
    isAdmission: boolean = null;
    appointmentId: string = null;
    appointmentIdr: string = null;
    routingValue: string = null;
    pediatricEncounter: any = null;
    specialFeature: OB.SpecialFeature;
    allergies: OB.Allergies;
    allergiesdata: IEncounterResource;
    appointment: any = null;
    encounterCommunicationSubscription: Subscription;
    fatherName: string;
    commonData: IEncounterResource;
    patientIdd: any;
    roleId: number;
    appointments: any;
    oldAppointment: any;


    constructor(
        private readonly appData: AppData,
        private readonly httpService: HttpService,
        private readonly encounterCommunication: EncounterCommunication,
        private readonly router: Router,
    ) { 
        this.page = new Page();
       
    }
    

    @Input() patientId: string;
    @Input() appointmentIdd: string;
    @Input() encryptedPatientId: string;
    @Input() encryptedAppointmentId: string;
    
    ngOnInit() {
        this.appData.userAccount
            .pipe(takeUntil(this.page.unSubscribe))
            .subscribe((userAccount: IUserAccount) => {
                if (userAccount) {
                    this.page.userAccount = userAccount;
                    const url = this.router.url;
                    this.isAdmission = url.split("/")[4] === "a";
                    this.appointmentId = url.split("/")[url.split("/").length - 3];
                    this.roleId = this.page.userAccount.roleId;
                    //this.findAppointment(appointmentId);
                    const appointmentId = decodeURIComponent(url.split("/")[url.split("/").length - 3]);
                    this.roleId = this.page.userAccount.roleId;
                    this.isAdmission = url.split("/")[4] === "a";
                    this.encounterCommunicationSubscription = this.encounterCommunication.pEncounter.subscribe(() => {
                        this.findPatient();
                        this.findAppointment(appointmentId);
                        this.findDashboard();
                        this.findCommonData();
                    })
                }
            })
    }

        @HostListener('window:resize')
        onResize() {
            this.paddingTop();
        }
        @HostListener('window:load')
        onLoad() {
            setTimeout(() => { this.paddingTop(); }, 1500)
        }
        @HostListener('window:hashchange')
        onhashchange() {
            setTimeout(() => { this.paddingTop(); }, 500)
        }
    paddingTop() {
        if (document.getElementById("header") != null && document.getElementsByClassName("content")[0] != null) {
            var paddingTopValue = document.getElementById("header").offsetHeight;
            var content = document.getElementsByClassName("content")[0];
            content.setAttribute('style', `padding-top:${paddingTopValue}px`);
        }
    }

    private findAppointment(appointmentId: string) {
        const request = {
            encryptedAppointmentId: appointmentId
        };
        request["isAdmission"] = this.isAdmission;
        this.httpService.post<Appointment>(ApiResources.getURI(ApiResources.appointments.base, ApiResources.appointments.findAppointment), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: Appointment) => {
                this.appointment = response;
                this.findPatientDetails();
                
                this.paddingTop();
            });
    }
    private findPatient() {
        
                this.page.loading = true;
                const request = { encryptedAppointmentId: this.appointmentId };
                request["isAdmission"] = this.isAdmission;
                this.httpService.post<PEncounter>(ApiResources.getURI(ApiResources.appointments.base, ApiResources.appointments.findAppointment), request)
                    .pipe(takeUntil(this.page.unSubscribe))
                    .subscribe((response: PEncounter) => {
                        this.patientId = response.encryptedPatientId;

                        this.findPatientDetails();
                    });
            }
  
   

  
    private findPatientDetails() {
        this.page.loading = true;
        this.httpService.post<PatientProfile>(ApiResources.getURI(ApiResources.patients.base, ApiResources.patients.profile), { encryptedPatientId: this.appointment.encryptedPatientId })
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: PatientProfile) => {
                if (response) {
                    this.patient = response;
                    var detaills = this.patient.relativeDetails[0];
                    if (detaills && detaills.relation == "Father") {
                        this.fatherName = this.patient.relativeDetails[0].fullName
                    }
                }
            });
    }
    


    private findDashboard() {
        const request = {
            encryptedAppointmentId: this.appointmentId,
            encryptedProviderId: this.page.userAccount && this.page.userAccount.encryptedReferenceId ? this.page.userAccount.encryptedReferenceId : null,
            encryptedPatientId: this.patientId,
            isAdmission: this.isAdmission
        };
        request["isAdmission"] = this.isAdmission;
        this.httpService.post<[PEncounter, Appointment, PreviousAppointment]>(ApiResources.getURI(ApiResources.pediatricEncounter.base, ApiResources.pediatricEncounter.findData), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: [PEncounter, Appointment, PreviousAppointment]) => {
                this.pediatricEncounter = response["dashboard"];
                this.appointments = response["appointments"];
                this.oldAppointment = response["oldAppointment"];
                if (this.pediatricEncounter && this.pediatricEncounter.pediatricEncounterId) {
                    this.measurements = this.pediatricEncounter.measurements ? JSON.parse(this.pediatricEncounter.measurements) : null;
                    this.allergies = this.pediatricEncounter.allergies ? JSON.parse(this.pediatricEncounter.allergies) : null;
                    this.specialFeature = this.pediatricEncounter.specialFeature ? JSON.parse(this.pediatricEncounter.specialFeature) : null;
                }
                })

    }
   

    private findCommonData() {
        const request = {
            encryptedappointmentid: this.appointmentId,
            encryptedpatientid: this.patientId,
        };
        request["isAdmission"] = this.isAdmission;
        this.httpService.post<IEncounterResource>(ApiResources.getURI(ApiResources.pediatricEncounter.base, ApiResources.pediatricEncounter.findData), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: IEncounterResource) => {
                this.commonData = response;
                console.log(response);
                

            });
    }

    ngOnDestroy() {
        this.page.unsubscribeAll();
        this.encounterCommunicationSubscription.unsubscribe();
    }
}



